import * as React from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Dispatch } from "redux";
import {
  setShouldRequestInsights,
  setShouldRequestMonitoring,
} from "../../redux/modules/_BETA/requestSchedule";
import { ProjectSettings } from "../../components/ProjectSettings/";
import NotFound from "../../containers/NotFound/NotFound";
import { InsightType } from "../../utils/routes";
import { useActions as useConfigActions } from "../../context/settings/config/useActions";
import { useActions as useRulesActions } from "../../context/settings/rules/useActions";

interface Props {
  projectList: Insite.Project[];
  sites: Insite.AppState["userSites"]["sites"];
  siteList: Insite.AppState["userSites"]["sites"][];
  user: Insite.AppState["auth"]["user"];
  insightType: InsightType;
  setRequestInsightsFlag(): void;
}

const ProjectSettingsScene: React.FC<Props> = ({
  sites,
  siteList,
  projectList,
  user,
  insightType,
  setRequestInsightsFlag,
}) => {
  if (user.groups && !user.groups.includes("ConserveIt")) {
    return <NotFound />;
  }

  const { updateInsightType } = useConfigActions();
  const { getRules } = useRulesActions();

  React.useEffect(() => {
    void getRules();
  }, []);

  React.useEffect(() => {
    updateInsightType(insightType);
  }, [insightType]);

  return (
    <React.Fragment>
      <Helmet title="Project Settings" />
      <ProjectSettings
        onSave={setRequestInsightsFlag}
        projectList={projectList}
        sites={sites}
        siteList={siteList}
      />
    </React.Fragment>
  );
};

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setRequestInsightsFlag: () => {
      dispatch(setShouldRequestInsights(true));
      dispatch(setShouldRequestMonitoring(true));
    },
  };
}

export default connect(null, mapDispatchToProps)(ProjectSettingsScene);
